import Text from '@/components/atoms/Text';
import * as S from './styles';
import { theme } from '@/styles/theme';
import formatarDataExtensa from '@/utils/formatarDataExtensa';
import Avatar from '@/components/atoms/Avatar';

interface InformacoesPublicacaoProps {
  image: string | null | undefined;
  author: string;
  date: string;
  duration: number;
  style?: CSSProperties;
}

import imagem_default_usuario from '@/assets/DefaultUser.jpg';
import { CSSProperties } from 'react';

export default function InformacoesPublicacao(
  props: InformacoesPublicacaoProps,
) {
  const { image, author, date, duration, style = {} } = props;
  return (
    <S.Container style={style}>
      <Avatar
        $size={2}
        $shape="square"
        $variant="solid"
        $color="neutral"
        $preencherFundo
        $image={image || imagem_default_usuario}
      />
      <S.Content>
        <Text
          $size={1}
          $align="left"
          $fontFamily="news"
          $highContrast={false}
          $weight="medium"
          $color={theme.tokens.colors.news.description}
          $text={author}
          style={{
            lineHeight: undefined,
          }}
        />
        <Text
          $size={1}
          $align="left"
          $fontFamily="news"
          $highContrast={false}
          $weight="regular"
          $color={theme.tokens.colors.news.description}
          $text={`${formatarDataExtensa(date)} - ${duration} min leitura`}
          style={{
            lineHeight: undefined,
          }}
        />
      </S.Content>
    </S.Container>
  );
}
